<template>
    <section>
        <product-renderer
            :show-toolbar="showToolbar"
            :show-zoom="showZoom"
            :show-fullscreen-button="showFullscreenButton"
            :image-zoom-percent="imageZoomPercent"
            :top-offset="topOffset"
        />
    </section>
</template>

<script>
    import ProductRenderer from './ProductRenderer.vue';

    export default {
        props: {
            showToolbar: {
                type: Boolean,
                default: true,
            },
            showZoom: {
                type: Boolean,
                default: false,
            },
            showFullscreenButton: {
                type: Boolean,
                default: false,
            },
            imageZoomPercent: {
                type: Number,
                default: 100,
            },
            topOffset: {
                type: Number,
                default: 0,
            },
        },

        components: {
            ProductRenderer,
        },
    };
</script>
